import { Component, ElementRef, input, ViewChild } from '@angular/core';

import { PrivaButtonComponent, PrivaButtonIconStateType } from '@priva/components/button';

@Component({
    selector: 'app-scan-button',
    templateUrl: './scan-button.component.html',
    styleUrl: './scan-button.component.scss',
    imports: [PrivaButtonComponent],
})
export class ScanButtonComponent {
    text = input('');
    iconState = input<PrivaButtonIconStateType>('none');
    iconClass = input('');
    isClickable = input(true);

    @ViewChild('scanBtn', { read: ElementRef })
    scanBtn!: ElementRef<HTMLElement>;

    onClick() {
        this.scanBtn.nativeElement.blur();
    }
}
